// api/sessionApi.ts
import { baseApi } from "./BaseApi";
import {
  AuthCodeExchangeResponse,
  ExchangeCodeRequest,
} from "../types/authTypes";
import { User } from "../types/commonTypes";

const sessionApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    exchangeCodeForToken: builder.mutation<
      AuthCodeExchangeResponse,
      ExchangeCodeRequest
    >({
      query: ({ clientId, code, redirectUrl }) => {
        const params = new URLSearchParams();
        params.append("code", code);
        params.append("grant_type", "authorization_code");
        params.append("client_id", clientId);
        // params.append("redirect_uri", redirectUrl);
        const p = params.toString() + `&redirect_uri=${redirectUrl}`;
        const base_url =
          "https://diditusa.auth.us-west-2.amazoncognito.com/oauth2/token";
        const url = `${base_url}?${p}`;
        return {
          url,
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        };
      },
    }),

    loadUser: builder.query<User, void>({
      query: () => ({
        url: `/user`,
        headers: { "X-SAEF-ACCESS-TOKEN": "" },
      }),
      providesTags: ["User"],
    }),

    handleLoginInviteToken: builder.mutation<void, string>({
      query: (token) => ({
        url: "/token/login",
        method: "POST",
        body: { token },
      }),
      invalidatesTags: ["User"],
    }),
  }),
});

export const {
  useExchangeCodeForTokenMutation,
  useLoadUserQuery,
  useLazyLoadUserQuery,
  useHandleLoginInviteTokenMutation,
} = sessionApi;

export default sessionApi;
